import React from 'react'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'

import { AlertOctagonIcon, CheckCircleIcon } from 'components/shared/Icon/model'

const INVALID = 'invalid'
const VALID = 'valid'

type StatusOptions = {
  isFinished?: boolean
  isInvalid?: boolean
}

export const getStatuses = ({ isFinished, isInvalid }: StatusOptions) => [
  {
    icon: AlertOctagonIcon,
    id: uuidv4(),
    ref: React.createRef<HTMLElement>(),
    type: INVALID,
    isInitialised: R.and(isInvalid, !isFinished),
  },
  {
    icon: CheckCircleIcon,
    id: uuidv4(),
    ref: React.createRef<HTMLElement>(),
    type: VALID,
    isInitialised: R.and(isFinished, !isInvalid),
  },
]
